import { render } from "./AppNavigationTracksItem.vue?vue&type=template&id=0cd654c2&scoped=true"
import script from "./AppNavigationTracksItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationTracksItem.vue?vue&type=script&lang=js"

import "./AppNavigationTracksItem.vue?vue&type=style&index=0&id=0cd654c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd654c2"]])

export default __exports__